export default "__VITE_ASSET__Bs2KbH$4__"